module.exports = __webpack_public_path__ + "img/ImageQstep1.0f16b43b.png";